import angular from 'angular';
import geolocation from 'angularjs-geolocation';

// Libraries

// Translations
import translation from '../../../../../lib/translation';

// Load all services
import '../../../../../lib/service';
import taskQueueServiceModule from '../../../../../lib/service/TaskQueueService';

// Component
import component from './opportunityDisplayBox.component';

// Dependencies
import constants from '../../../../../lib/constants';
import filters from '../../../../../lib/filters';
import opportunityDetailsModalModule from '../opportunityDetailsModal';
import filesModalModule from '../filesModal';

const moduleName = 'staff.dashboardScreen.opportunityDisplayBox';
let module = angular.module(moduleName, [
  'recaps.services',
  translation,
  'angularMoment',
  'geolocation',
  constants,
  taskQueueServiceModule.name,
  opportunityDetailsModalModule.name,
  filesModalModule.name,
  filters.name,
]);

module.component('opportunityDisplayBox', component);

export default module;
